// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "segment-JeXsn";
var _4 = "locationsWrapper-2eTcs";
var _5 = "location-3ZDiZ";
var _6 = "flight-3Ci4R";
export { _1 as "__esModule", _2 as "mobile", _3 as "segment", _4 as "locationsWrapper", _5 as "location", _6 as "flight" }
export default { "__esModule": _1, "mobile": _2, "segment": _3, "locationsWrapper": _4, "location": _5, "flight": _6 }
